Ext.define('SA.FilterPredicate', {
    statics: {
        between(attribute, min, max) {
            return new SA.FilterPredicate('between', attribute, [min, max]);
        },

        equal(attribute, comparand) {
            return new SA.FilterPredicate('=', attribute, comparand);
        },

        greaterThan(attribute, comparand) {
            return new SA.FilterPredicate('>', attribute, comparand);
        },

        greaterThanOrEqual(attribute, comparand) {
            return new SA.FilterPredicate('>=', attribute, comparand);
        },

        lessThan(attribute, comparand) {
            return new SA.FilterPredicate('<', attribute, comparand);
        },

        lessThanOrEqual(attribute, comparand) {
            return new SA.FilterPredicate('<=', attribute, comparand);
        },

        notEqual(attribute, comparand) {
            return new SA.FilterPredicate('<>', attribute, comparand);
        }
    },

    constructor(operator, attribute, comparand) {
        this.attribute = attribute;
        this.comparand = comparand;
        this.operator = operator;
    },

    getAttribute() {
        return this.attribute;
    },

    getComparand() {
        return this.comparand;
    },

    getOperator() {
        return this.operator;
    },

    isBetween() {
        return this.getOperator() === 'between';
    },

    isEqual() {
        return this.getOperator() === '=';
    },

    isGreaterThan() {
        return this.getOperator() === '>';
    },

    isGreaterThanOrEqual() {
        return this.getOperator() === '>=';
    },

    isLessThan() {
        return this.getOperator() === '<';
    },

    isLessThanOrEqual() {
        return this.getOperator() === '<=';
    },

    isNotEqual() {
        return this.getOperator() === '<>';
    }
});